import { render, staticRenderFns } from "./SnippetManager.vue?vue&type=template&id=39bd65ae&scoped=true"
import script from "./SnippetManager.vue?vue&type=script&lang=js"
export * from "./SnippetManager.vue?vue&type=script&lang=js"
import style0 from "./SnippetManager.vue?vue&type=style&index=0&id=39bd65ae&prod&lang=less&scoped=true"
import style1 from "./SnippetManager.vue?vue&type=style&index=1&id=39bd65ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.2.37_babel-core@7.0.0-bridge.0_@babel+core@7.27._34821b905de301c85186a14781ffb397/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd65ae",
  null
  
)

export default component.exports